// eslint-disable-next-line
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

//mui component
import {
  AppBar,
  Box,
  Stack,
  Drawer as MuiDrawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Avatar,
  Button,
  Grid,
  Toolbar,
  Typography,
  ListItemButton,
  Menu,
  Link as MuiLink,
  MenuItem,
  Modal,
  Skeleton,
  LinearProgress,
  styled,
  keyframes,
} from "@mui/material";
import { useTheme as themee } from "@mui/material";

import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import SearchIcon from "@mui/icons-material/Search";
//mui icons
import AppsIcon from "@mui/icons-material/Apps";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import CloudOutlinedIcon from "@mui/icons-material/CloudOutlined";
import { fileManager } from "../services/sidebarLinks";
import { useTheme } from "../style/theme";

//react component
import Image from "../components/Image";

//services
import { useMenu } from "../hooks/useMenu";

import SearchBar from "./SearchBar";
import axios from "axios";
import { useMessage } from "./Header";
import { useUser } from "../hooks/Authorize";
import useModal from "./../hooks/useModal";
import { clearCookie, getCookie } from "../utilities/cookies";
import { env } from "../utilities/function";
import Feedback from "./Feedback";
import MicrophoneIcon from "./MicrophoneIcon";
import SideBar from "./SideBar";
import { useNavigate } from "react-router-dom";
// import AdminLogo from "../components/images/adminLogo.png";
import { PlusIcon, Search, SearchXIcon } from "lucide-react";
import IconLib from "./IconLib";
import { borderTop } from "@mui/system";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ApiHealthModal from "./ApiHealthModal";

const drawerWidth = 260;
const appsWidth = 54;
const miniDrawerWidth = 105;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: theme.palette.background.default,
  borderRight: "none",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: theme.palette.background.default,
  overflowX: "hidden",
  width: `calc(${theme.spacing(8)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(12)} + 1px)`,
  },
  borderRight: "none",
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,

  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
const getInitials = (user) => {
  if (user && (user.firstName || user.lastName)) {
    const firstInitial = user.firstName?.charAt(0).toUpperCase() || "";
    const lastInitial = user.lastName?.charAt(0).toUpperCase() || "";
    return `${firstInitial}${lastInitial}`;
  } else return "?";
};

export default function Navbar(props) {
  const navigate = useNavigate();

  const [collapsesState, setCollapsesState] = useState({});
  const [isSearching, setIsSearching] = useState(false);
  const handleSearchToggle = () => {
    setIsSearching((prev) => !prev); // Toggle the state
  };
  const modifyCollapsesState = (label) => {
    setCollapsesState((prevState) => ({
      ...prevState,
      [label]: !prevState[label],
    }));
  };
  const { children } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarApps, setSidebarApps] = useState(null);
  const [isCamera, setIsCamera] = useState(false);
  const [user, setUser] = useState(null);
  // Always keep drawer collapsed on large screens
  const collapseDrawer = false;
  // Remove hover behavior on large screens
  const drawerHover = false;
  const {
    modalState: feedbackState,
    openModal: openFeedback,
    closeModal: closeFeedback,
  } = useModal();
  const { showError } = useMessage();
  const location = useLocation();

  const pathParts = location.pathname.split("/"); // e.g., ["", "subscription", "subscription-by-product"]
  const basePath = `/${pathParts[1]}`; // e.g., "/subscription"
  const cameraImg =
    "https://www.citypng.com/public/uploads/preview/camera-black-icon-download-png-7017516950352149rvpkextdt.png";
  // Find the selected tab based on the base path

  const platformUser = useUser();
  const [selectedTab, setSelectedTab] = useState(
    fileManager.find((tab) => tab.to === basePath)
  );
  const { toggleTheme, mode } = useTheme();
  const [healthModalOpen, setHealthModalOpen] = useState(false);
  useEffect(() => {
    const currentTab = fileManager.find((tab) => tab.to === basePath);
    if (currentTab) {
      setSelectedTab(currentTab);
    }
  }, [basePath]);
  // useMenu
  const {
    anchorEl: anchorElProfile,
    openMenu: openProfileMenu,
    closeMenu: closeProfileMenu,
  } = useMenu();

  const {
    anchorEl: anchorElApps,
    openMenu: openAppsMenu,
    closeMenu: closeAppsMenu,
  } = useMenu();

  const {
    anchorEl: anchorElSettings,
    openMenu: openSettingsMenu,
    closeMenu: closeSettingsMenu,
  } = useMenu();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const defaultImg = "https://shorturl.at/fjqz9";
  const [imageSrc, setImageSrc] = useState("https://shorturl.at/fjqz9");
  const fileInputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageSrc(URL.createObjectURL(file));
    }
  };

  const getProfile = useCallback(async () => {
    const role = getCookie("role");
    const accessToken = localStorage.getItem("accessToken");
    const user = JSON.parse(localStorage.getItem("user"));
    if (!(accessToken && role)) return;

    try {
      const response = await axios.get(
        `/api/auth/get_user_profile`,
        { id: user._id },
        {
          baseURL: "https://accounts.wurknest.com:6050",
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      const user = response.data.user;
      setUser(user);
    } catch (err) {
      console.log(err);
    }
  }, [setUser]); // fetching user to get its personalize settings

  const getPlatforms = useCallback(async () => {
    try {
      const response = await axios.get("/platforms?sortBy=name&direction=1", {
        baseURL: env("AUTHENTICATION_SERVER"),
      });

      const { success, errors, platforms } = response.data;

      if (!success) return showError(errors);

      const SidebarApps = platforms?.filter(
        (platform) => platform.slug !== "e-sign"
      ); // Platform to exclude from list

      SidebarApps.forEach((app, i) => (app.order = i + 1));

      const arrangedOrder = [];
      user?.personalize?.appsOrder.forEach((order) => {
        SidebarApps.forEach((app, i) => {
          if (order === app.order) {
            arrangedOrder.push(app);
            SidebarApps.splice(i, 1);
          }
        });
      });

      if (arrangedOrder.length)
        setSidebarApps([...arrangedOrder, ...SidebarApps]);
      else setSidebarApps(SidebarApps);
    } catch (e) {
      console.log(e);
    }
  }, [user, showError]);
  const [isVibrating, setIsVibrating] = useState(false);
  // const user = useUser();

  const oscillate = keyframes`
    0% { transform: rotate(0deg); }
    10% { transform: rotate(15deg); }
    20% { transform: rotate(20deg); }
    30% { transform: rotate(15deg); }
    40% { transform: rotate(0deg); }
    50% { transform: rotate(-10deg); }
    60% { transform: rotate(-15deg); }
    70% { transform: rotate(-10deg); }
    80% { transform: rotate(0deg); }
    90% { transform: rotate(10deg); }
    100% { transform: rotate(0deg); }
  `;

  const handleBellClick = () => {
    setIsVibrating(true);
    setTimeout(() => setIsVibrating(false), 1000);
  };
  const signOut = () => {
    clearCookie("accessToken");
    clearCookie("role");
    clearCookie("setupCompleted");
    localStorage.clear();
    const redirectTo =
      "https://accounts.wurknest.com/logout?redirectto=https://wurknest.com";
    window.location.replace(redirectTo);
  };

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    getProfile();
  }, [getProfile]);

  useEffect(() => {
    user && getPlatforms();
  }, [user, getPlatforms]);
  const theme = themee();

  const drawer = (
    <Box
      minHeight="100dvh"
      color="text.secondary"
      display="flex"
      flexDirection="column"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        component={Link}
        to="/"
        sx={{ textDecoration: "none", color: "text.primary", py: 1 }}
      >
        <Box display="flex" alignItems="center" gap={1} sx={{ m: 2 }}>
          <img
            src="https://cdn.wurknest.com/images/worknest%20app%20icon%20Transprant-01.png"
            alt="logo"
            style={{ width: "40px", height: "40px" }}
          />
          <Typography variant="h6" fontWeight="bold" color="text.primary">
            Wurknest Admin
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{ overflowY: "auto", height: "calc(100dvh - 90px)", flexGrow: 1 }}
      >
        {/* 
        <List sx={{ px: 3 }}>
          {fileManager.map((link) => (
            <NavLink
              to={link.to}
              key={link.name}
              style={{ textDecoration: "none", color: "inherit" }}
                     className={({ isActive }) =>
            true
              ? "whitespace-nowrap text-xl border-b-4 border-[#2394f6] text-[#2394f6]"
              : "whitespace-nowrap text-xl text-gray-500 hover:text-[#2394f6]"
          }
            >
              {({ isActive }) => (
                <ListItem disablePadding>
                  <ListItemButton
                    selected={isActive}
                    disableRipple
                    disableTouchRipple
                    variant="sidebarButton"
                    
                  >
                    <ListItemIcon
                      sx={{ 
                        minWidth: "35px",
                        color: "text.secondary",
                      }}
                      
                    >
                      {link.icon}
                    </ListItemIcon>
                    <ListItemText primary={link.name} />
                  </ListItemButton>
                </ListItem>
              )}
            </NavLink>
          ))}
        </List> */}

        <List sx={{ px: 3 }}>
          {fileManager.map((link) => (
            <NavLink
              to={link.to}
              key={link.name}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              {({ isActive }) => (
                <ListItem disablePadding>
                  <ListItemButton
                    selected={isActive}
                    disableRipple
                    disableTouchRipple
                    variant="sidebarButton"
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "35px",
                        color: "text.secondary",
                      }}
                    >
                      <img src={link.icon} width={20} />
                    </ListItemIcon>
                    <ListItemText primary={link.name} />
                  </ListItemButton>
                </ListItem>
              )}
            </NavLink>
          ))}
        </List>
      </Box>

      <Box>
        <Divider variant="middle" />
        <Typography
          variant="body2"
          pl={3}
          mt={1.5}
          fontSize="14px"
          fontWeight={500}
        >
          Storage
        </Typography>

        <Box px={3} pb={3}>
          <LinearProgress
            variant="determinate"
            value={20}
            color="primary"
            sx={{ borderRadius: "2px", mt: 1 }}
          />
          <Typography
            variant="caption"
            component="div"
            mt={1}
            color="primary.main"
          >
            1 GB used of 5 GB
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<CloudOutlinedIcon fontSize="small" />}
            sx={{ mt: 1, color: "white" }}
            href={env("MY_ACCOUNT")}
            fullWidth
          >
            Upgrade storage
          </Button>
        </Box>
        <Divider
          variant="middle"
          sx={{ display: { xs: "block", sm: "none" } }}
        />
        <List sx={{ px: 1, display: { xs: "block", sm: "none" } }}>
          <ListItem
            disablePadding
            onClick={openSettingsMenu}
            // sx={{
            //   "&:hover": {
            //     backgroundColor: "custom.cardHover",
            //     borderRadius: "8px",
            //   },
            // }}
          >
            <ListItemButton
              disableRipple
              disableTouchRipple
              variant="sidebarButton"
            >
              <ListItemIcon
                sx={{
                  minWidth: "30px",
                  color: "text.secondary",
                }}
              >
                <SettingsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Settings"
                primaryTypographyProps={{ fontSize: 14 }}
              />
            </ListItemButton>
          </ListItem>
        </List>

        <Stack
          direction="row"
          justifyContent="center"
          my={1}
          sx={{ display: { xs: "none", sm: "flex" } }}
        >
          <MuiLink
            display="inline-flex"
            alignItems="center"
            color="text.secondary"
            sx={{ cursor: "pointer" }}
            onClick={openFeedback}
          >
            <MicrophoneIcon />
            <Typography variant="caption" fontWeight="bold">
              Give feedback
            </Typography>
          </MuiLink>
        </Stack>
      </Box>
    </Box>
  );
  const miniDrawer = (
    <Box
      minHeight="100dvh"
      color="text.secondary"
      display="flex"
      flexDirection="column"
      alignSelf="flex-end"
      position={"absolute"}
      bottom={0}
      left={0}
    >
      <Box
        sx={{
          position: "fixed",
          top: "16px",
          left: "26px",
          zIndex: 9999999,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <img
          src="https://cdn.wurknest.com/images/worknest%20app%20icon%20Transprant-01.png"
          style={{
            height: "30px",
            width: "40px",
          }}
          alt="Wurknest"
        />
        <Typography variant="h6" fontWeight="bold" color="text.primary" sx={{ whiteSpace: "nowrap" }}>
          Wurknest Admin
        </Typography>
      </Box>
      <Box
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
          height: "calc(100dvh - 90px)",
          flexGrow: 1,
          pt: "67px",
        }}
      >
        <List
          sx={{
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          {fileManager.map((link) => (
            <NavLink
              to={link.to}
              key={link.to}
              style={{
                textDecoration: "none",
                color: "inherit",
                textDecoration: "none",
                whiteSpace: "nowrap",
                fontWeight: 700,
                fontSize: "1.25rem",
                // paddingBottom: '0.5rem',

                color: theme.palette.text.secondary,
                "&:hover": {
                  color: theme.palette.primary.main,
                },
                "&.active": {
                  color: theme.palette.primary.main,
                  borderBottom: `3px solid ${theme.palette.primary.main}`,
                },
              }}
            >
              {({ isActive }) => (
                <ListItem disablePadding>
                  <ListItemButton
                    disableRipple
                    disableTouchRipple
                    variant="sidebarButton"
                    {...(Array.isArray(link.to)
                      ? {
                          selected: collapsesState[link.name],
                          onClick: () => modifyCollapsesState(link.name),
                        }
                      : {
                          to: link.to,
                          // selected: isActive,
                        })}
                    sx={{ height: "auto", my: "3px" }}
                  >
                    <ListItemIcon
                      sx={{
                        // minWidth: '35px',
                        color: "text.secondary",
                      }}
                      className="w-[4.25rem]  flex flex-col gap-[0.15rem] justify-center items-center"
                    >
                      <div
                        className={` ${isActive ? "text-[#2394f6]" : ""} ${
                          mode === "dark" ? "bg-neutral-800" : "bg-neutral-200"
                        }  bg-opacity-50 p-2 rounded-lg`}
                      >
                        <img
                          src={link.icon}
                          width={23}
                          style={{
                            filter: isActive
                              ? "brightness(0) saturate(100%) invert(44%) sepia(98%) saturate(1548%) hue-rotate(187deg) brightness(101%) contrast(101%)"
                              : "none",
                          }}
                        />
                      </div>
                      <h1
                        className={`  ${
                          isActive ? "text-[#2394f6]" : ""
                        } text-[0.7rem]`}
                      >
                        {link.name}
                      </h1>
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
              )}
            </NavLink>
          ))}
        </List>
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        px: { xs: 0.5, xm: 0 },
        height: "100dvh",
        position: "relative",
      }}
    >
      <AppBar
        elevation={0}
        component={Box}
        position="sticky"
        sx={{
          width: {
            xs: "100%",
            xm: `calc(100% - ${miniDrawerWidth}px)`,
          },
          ml: {
            xm: `${miniDrawerWidth}px`,
          },
          backgroundColor: "background.default",
          borderBottom: "1px solid custom.border",
          color: "text.primary",
          transition: "ease-in-out 225ms, background-color 0s",
        }}
      >
        <Toolbar
          sx={{
            flexDirection: "column",
            justifyContent: "center",
            position: "relative",
            borderBottom: `1px solid ${theme.palette.divider}`,
            mb: 1,
            "&": {
              minHeight: "68px",
              px: 1,
            },
            "@media (min-width: 600px)": {
              pl: "150px",
            },
          }}
        >
          <Grid container alignItems="center" columnSpacing={1}>
            <Grid item>
              <IconButton
                onClick={handleDrawerToggle}
                edge="start"
                sx={{
                  ml: 0.2,
                  mr: 1,
                  display: { xs: "flex", xm: "none" }, // Only show hamburger on mobile
                }}
              >
                <MenuIcon sx={{ fontSize: "30px" }} />
              </IconButton>
            </Grid>

            <div>
              <div className="flex space-x-12 text-gray-400">
                {/* <div
                      className="whitespace-nowrap text-xl"
                      sx={{ width: 100 }}
                    >
                      <span className="font-extrabold size-7 font">Wurknest</span> Admin
                    </div> */}
                {selectedTab?.name === "Users" ||
                selectedTab?.name === "Subscription" ? (
                  <>
                    {/* <button
                          className={`whitespace-nowrap text-xl ${
                            selectedTab?.name === "Users"
                              ? "border-b-4 border-[#2394f6] text-[#2394f6]"
                              : "text-gray-400"
                          }`}
                          onClick={() => {
                            setSelectedTab({ name: "Users" });
                            navigate("/users"); // Replace with your actual route
                          }}
                        >
                          Users
                        </button> */}

                    <button
                      className={`whitespace-nowrap text-xl ${
                        selectedTab?.name === "Subscription"
                          ? "border-b-4 border-[#2394f6] text-[#2394f6]"
                          : "text-gray-400"
                      }`}
                      onClick={() => {
                        setSelectedTab({ name: "Subscription" });
                        navigate("/subscription"); // Replace with your actual route
                      }}
                    >
                      Subscription
                    </button>
                  </>
                ) : (
                  <button
                    className={`whitespace-nowrap text-xl border-b-4 border-[#2394f6] text-[#2394f6]`}
                  >
                    {selectedTab?.name}
                  </button>
                )}
              </div>
            </div>

            <Grid item xs display={{ xs: "none", sm: "block" }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                spacing={0.6}
              >
                <Grid
                  item
                  xs
                  md={5}
                  paddingLeft={10}
                  alignItems="flex-start"
                  sx={{
                    marginLeft: 0.5,
                  }}
                >
                  {isSearching && <SearchBar />}
                </Grid>
                
                <IconButton onClick={() => setHealthModalOpen(true)}>
                  <VisibilityIcon />
                </IconButton>

                <IconButton
                // onClick={handleOpenMenu}
                >
                  {/* <PlusIcon  width={35}/> */}
                  <img src={IconLib.addButton} width={30} alt="upload-file" />
                </IconButton>

                <IconButton
                  onClick={() => {
                    setIsSearching(!isSearching);
                  }}
                >
                  {mode === "dark" ? (
                    // <SearchXIcon  width={25} />
                    <img src={IconLib.ggSearch} width={30} alt="" />
                  ) : (
                    // <SearchXIcon  width={25} />

                    <img src={IconLib.ggSearchlm} width={30} alt="" />
                  )}
                </IconButton>
                <IconButton
                  onClick={handleBellClick}
                  sx={{
                    animation: isVibrating
                      ? `${oscillate} 1s ease-in-out`
                      : "none",
                  }}
                >
                  {mode === "dark" ? (
                    <img src={IconLib.bytesizeBell} width={30} alt="" />
                  ) : (
                    <img src={IconLib.bytesizeBelllm} width={30} alt="" />
                  )}
                </IconButton>
                {/* <IconButton
                  onClick={() =>
                    window.open("https://app.wurknest.com", "_blank")
                  }
                >
                  {mode === "dark" ? (
                    <img
                      src={IconLib.iconParkOutlineMessage}
                      width={25}
                      alt=""
                    />
                  ) : (
                    <img
                      src={IconLib.iconParkOutlineMessagelm}
                      width={25}
                      alt=""
                    />
                  )}
                </IconButton> */}
                {/* <IconButton
                  onClick={() =>
                    window.open("https://app.wurknest.com", "_blank")
                  }
                >
                  {mode === "dark" ? (
                    <img src={IconLib.basilVideoOutline} width={25} alt="" />
                  ) : (
                    <img src={IconLib.basilVideoOutlinelm} width={25} alt="" />
                  )}
                </IconButton> */}
                <IconButton
                  onClick={() =>
                    window.open("https://app.wurknest.com", "_blank")
                  }
                >
                  {mode === "dark" ? (
                    <img src={IconLib.feAppMenu} width={30} alt="" />
                  ) : (
                    <img src={IconLib.feAppMenulm} width={30} alt="" />
                  )}
                </IconButton>
                <IconButton onClick={openSettingsMenu}>
                  {mode === "dark" ? (
                    <img src={IconLib.mdiLightSettings} width={30} alt="" />
                  ) : (
                    <img src={IconLib.mdiLightSettingslm} width={30} alt="" />
                  )}
                </IconButton>
                <Menu
                  anchorEl={anchorElSettings}
                  open={Boolean(anchorElSettings)}
                  onClose={closeSettingsMenu}
                >
                  <MenuItem onClick={toggleTheme}>
                    <ListItemIcon>
                      {mode === "dark" ? (
                        <LightModeIcon fontSize="small" />
                      ) : (
                        <DarkModeIcon fontSize="small" />
                      )}
                    </ListItemIcon>
                    Appearance
                  </MenuItem>
                </Menu>
                <Menu
                  anchorEl={anchorElApps}
                  open={Boolean(anchorElApps)}
                  onClose={closeAppsMenu}
                  sx={{
                    ".MuiPaper-root.MuiMenu-paper.MuiPopover-paper": {
                      marginTop: "16px",
                      bgcolor: "custom.menu",
                      width: "300px",
                      padding: "10px 14px",
                      borderRadius: "8px",
                      boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                      border: "1px solid rgba(0, 0, 0, 0.11)",
                    },
                  }}
                >
                  <Grid container alignItems="center" spacing={2}>
                    {sidebarApps
                      ? sidebarApps.map((app) => (
                          <Grid item xs={4} key={app.name}>
                            <MuiLink
                              href={app.url}
                              target="_blank"
                              sx={{
                                fontWeight: 500,
                                textDecoration: "none",
                                color: "#5f6368",
                              }}
                            >
                              <Box
                                align="center"
                                sx={{
                                  borderRadius: "8px",
                                  p: 1.2,
                                  textAlign: "center",
                                  "&:hover": {
                                    bgcolor: "custom.appsHover",
                                  },
                                }}
                              >
                                <Image
                                  src={app.logo}
                                  sx={{
                                    height: "35px",
                                  }}
                                />
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    overflowX: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    fontWeight: 500,
                                  }}
                                >
                                  {app.name}
                                </Typography>
                              </Box>
                            </MuiLink>
                          </Grid>
                        ))
                      : Array(9)
                          .fill(0)
                          .map((_, i) => (
                            <Grid item xs={4} key={i} align="center">
                              <Skeleton
                                variant="circular"
                                animation="wave"
                                width={37}
                                height={37}
                                sx={{ mt: 1 }}
                              />
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={38}
                                sx={{ mt: 1 }}
                              />
                            </Grid>
                          ))}
                  </Grid>
                </Menu>
              </Stack>
            </Grid>
            <Grid item>
              <IconButton
                onClick={openProfileMenu}
                sx={{
                  borderWidth: "2px",
                  width: "45px",
                  height: "45px",
                  borderStyle: "solid",
                  borderColor: "primary.main",
                  p: "3px",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                {platformUser?.profilePicture ? (
                  <Box
                    component="img"
                    src={platformUser.profilePicture}
                    alt="Profile"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                ) : (
                  <Typography
                    variant="subtitle1"
                    component="div"
                    fontWeight={600}
                    fontSize="1.0rem"
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    {getInitials(platformUser)}
                  </Typography>
                )}
              </IconButton>

              <Menu
                anchorEl={anchorElProfile}
                open={Boolean(anchorElProfile)}
                onClose={closeProfileMenu}
                sx={{
                  ".MuiPaper-root.MuiMenu-paper.MuiPopover-paper": {
                    width: "min(100%, 320px)",
                    boxShadow:
                      "rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
                    border: "1px solid #00000017",
                    bgcolor: "custom.menu",
                    px: 0.5,
                    pt: 1.5,
                  },
                }}
              >
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  flexWrap="nowrap"
                >
                  <Grid
                    item
                    sx={{
                      borderWidth: "2px",
                      width: "85px",
                      marginLeft: "22px",
                      height: "85px",
                      marginTop: "10px",
                      borderRadius: "60px",
                      textAlign: "center",
                      borderStyle: "solid",
                      borderColor: "primary.main",
                      p: "8px",
                      overflow: "hidden",
                      position: "relative",
                      cursor: "pointer",
                      "&:hover .hoverIcon": {
                        opacity: 1,
                      },
                    }}
                  >
                    {platformUser?.profilePicture ? (
                      <Box
                        component="img"
                        src={platformUser.profilePicture}
                        alt="Profile"
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "50%",
                          position: "absolute",
                          top: 0,
                          left: 0,
                        }}
                      />
                    ) : (
                      <Typography
                        variant="subtitle1"
                        component="div"
                        fontWeight={600}
                        sx={{
                          fontSize: "1.5rem",
                          fontFamily: "sans-serif",
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: "100%",
                          textAlign: "center",
                          lineHeight: "1",
                        }}
                      >
                        {getInitials(platformUser)}
                      </Typography>
                    )}

                    <input
                      type="file"
                      id="profileUploadInput"
                      style={{ display: "none" }}
                      // accept="image/*"
                      // onChange={(e) => {
                      //   const file = e.target.files[0];
                      //   if (file) {
                      //     handleProfileUpload(e);
                      //   }
                      // }}
                    />

                    {/* <Box
                      className="hoverIcon"
                      onClick={() =>
                        document.getElementById("profileUploadInput")?.click()
                      }
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                        borderRadius: "50%",
                        padding: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 2,
                        width: "40px",
                        height: "40px",
                        opacity: 0,
                        transition: "opacity 0.3s ease",
                      }}
                    >
                      <CameraAltIcon
                        sx={{ color: "white", fontSize: "20px" }}
                      />
                    </Box> */}
                  </Grid>

                  <Grid item xs={8}>
                    <Typography
                      variant="substitle1"
                      component="div"
                      fontWeight={600}
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {platformUser.firstName + " " + platformUser.lastName}
                    </Typography>
                    <Typography
                      variant="caption"
                      component="div"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {platformUser.email}
                    </Typography>
                    <Typography
                      variant="caption"
                      component="a"
                      href={env("MY_ACCOUNT")}
                      color="primary.main"
                      display="block"
                    >
                      My Wurknest account
                    </Typography>
                    <Typography
                      variant="caption"
                      component="a"
                      href="#"
                      color="primary.main"
                      display="block"
                    >
                      My Profile
                    </Typography>
                  </Grid>
                </Grid>

                {/* {user && (
                  <StorageUsageWidget
                    userTotalSpacePlan={userTotalSpacePlan || ""}
                    user={user}
                  />
                )} */}

                <Stack direction="row" mt={2}>
                  <Button variant="text" fullWidth>
                    Add account
                  </Button>
                  <Button variant="text" onClick={signOut} fullWidth>
                    Sign out
                  </Button>
                </Stack>
              </Menu>
            </Grid>
          </Grid>
        </Toolbar>

        {/* <SideBar
          sidebarApps={sidebarApps}
          setSidebarApps={setSidebarApps}
          appsWidth={appsWidth}
        /> */}
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: { xm: drawerWidth },
          flexShrink: { sm: 0 },
          bgcolor: "custom.menu",
        }}
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <MuiDrawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", xm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              bgcolor: "custom.menu",
            },
          }}
        >
          {drawer}
        </MuiDrawer>
        <Drawer
          variant="permanent"
          open={collapseDrawer}
          sx={{
            display: { xs: "none", xm: "block" },
            position: "relative",

            p: 0,
            "& .MuiDrawer-paper": {
              boxShadow: drawerHover
                ? "rgba(149, 157, 165, 0.2) 0px 8px 24px"
                : "none",
            },
          }}
        >
          {collapseDrawer ? drawer : miniDrawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          width: {
            xs: "100%",
            xm:
              collapseDrawer && !drawerHover
                ? `calc(100% - ${drawerWidth + appsWidth}px)`
                : `calc(100% - ${appsWidth + miniDrawerWidth}px )`,
          },
          ml: {
            xm:
              collapseDrawer && !drawerHover
                ? `${drawerWidth}px`
                : `${miniDrawerWidth}px`,
          },
          mt: 1,
          height: { xs: "calc(100dvh - 90px)" },
          backgroundColor: "background.default",
          borderRadius: "12px",
        }}
      >
        {children}
      </Box>

      <Modal
        open={feedbackState}
        onClose={closeFeedback}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <>
          <Feedback closeModal={closeFeedback} />
        </>
      </Modal>
      <ApiHealthModal open={healthModalOpen} onClose={() => setHealthModalOpen(false)} />
    </Box>
  );
}
